export default "__VITE_ASSET__BoiuttF6__"